<template>
  <div
    v-dompurify-html="markdown"
    class="system-common-container"
    @click.prevent="jumpClick"
  />
</template>
<script lang="ts">
import EventBus from '_c/util/event-bus';
import { ChatPageEvents, ChatPageEventType } from '_c/typings/event/global';
import { defineComponent, inject, PropType } from 'vue';
import Showdown, { Converter } from 'showdown';
type SystemCommonViewData = {
  convert: Converter;
  chatPageEventBus: EventBus<ChatPageEvents>;
};
export default defineComponent({
  name: 'SystemCommonView',
  props: {
    content: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data(): SystemCommonViewData {
    return {
      convert: new Showdown.Converter(),
      chatPageEventBus: inject('chatPageEventBus') as EventBus<ChatPageEvents>,
    };
  },

  computed: {
    markdown() {
      return this.convert.makeHtml(this.content);
    },
  },

  methods: {
    jumpClick(e: MouseEvent): void {
      if (e.target !== null && (e.target as HTMLElement).tagName === 'A') {
        /// 修改昵称跳转拦截
        const { href } = (e.target as HTMLAnchorElement);
        const editNicReg = /kknk:\/\/msg-action\?action=edit_nick.?/;
        if (editNicReg.test(href)) {
          this.chatPageEventBus.emit(ChatPageEventType.editGrpNick, { gid: this.getQueryString(href, 'gid') ?? '' });
        }
      }
    },
    /// 获取链接查询参数
    getQueryString(href: string, name: string): string|null {
      const url = new URL(href);
      const { search } = url;
      const query = search.substring(1);
      const strArray = query.split('&');
      for (const str of strArray) {
        const pair = str.split('=');
        if (pair[0] === name) {
          return pair[1];
        }
      }
      return null;
    },
  },

});
</script>

<style lang="scss" src="./index.scss"/>

